import React from "react";

import { FaFacebook } from "react-icons/fa";


import cn from "classnames";

import styles from "./style.module.css";

const ButtonFb = (props) => {
  const { className} = props;
  const postUrl = "https://vilnohirsk-memory.com/";
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    postUrl
  )}`;

  const handleShareClick = () => {
    window.open(facebookShareUrl, "facebook_share", "width=600,height=400");
  };

  return (
    <button className={cn(styles.btn, className)} onClick={handleShareClick}>
      <FaFacebook />
    </button>
  );
};

export default ButtonFb;
